import React, { FunctionComponent, useState } from "react";
import { Box, Card, Stack, useTheme } from "@mui/material";
import { strings } from "../../../localization/LocalizedStrings";
import { useIsMobile } from "../../../hooks/isMobile";
import { ContentUnavailableNotice } from "../../attributes/ContentUnavailableNotice";
import { IAlbum } from "../../../hooks/albums";
import { AlbumList } from "../AlbumList";
import { FilterSortOption } from "../../../models/FilterElement";
import { IconType } from "../../../icons";
import styles from "./styles.module.scss";
import { ToolbarButton } from "../../toolbar/ToolbarButton";
import { PiperDivider } from "../../PiperDivider";
import { AlbumsDesktop } from "../AlbumsDesktop";

export const BoxSetAlbumList: FunctionComponent<IBoxSetAlbumListProps> = ({
  isPublic,
  className,
  boxSet,
  onDeleteFromBoxSet,
  onAddAlbum,
  onAlbumSelected,
  setLoading
}) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const [isAlbumsDesktopOpen, setIsAlbumsDesktopOpen] = useState(false);
  return (
    <Card
      elevation={5}
      className={className}
      sx={{
        position: "relative",
        display: "flex",
        height: boxSet.boxSetAlbums.length > 0 ? "auto" : "100%",
        flexDirection: "column",
        alignSelf: isMobile ? "center" : "stretch"
      }}
      style={{ backgroundColor: theme.palette.background.default }}
    >
      <Stack className={styles.albumsTitle} direction="row">
        <p className={styles.albumsText}>{strings.box_set_albums_title}</p>
        <Box flexGrow={1} />
        {!isPublic && (
          <ToolbarButton
            tooltip={strings.add_album}
            iconType={IconType.AddCircle}
            onClick={() => setIsAlbumsDesktopOpen(true)}
            loading={false}
          />
        )}
      </Stack>
      <PiperDivider />
      <AlbumList
        dragDropId={"box"}
        isBoxSetList={true}
        boxSetAlbumId={boxSet.uuid}
        albums={
          boxSet.boxSetAlbums
            ? [boxSet.boxSetAlbums?.map(boxSetAlbum => boxSetAlbum.album) ?? []]
            : undefined
        }
        isPublic={isPublic}
        sortOption={FilterSortOption.ARTIST}
        canMoveAlbums={true}
        canDropAlbums={true}
        canLoadMoreAlbums={false}
        noMoreAlbums={true}
        setNeedMoreAlbums={() => {
          //
        }}
        onAlbumSelected={onAlbumSelected}
        onAlbumDeletedFromBoxSet={onDeleteFromBoxSet}
        scrollToTopTrigger={false}
        isForLayout={false}
        setLoading={setLoading}
      />
      {boxSet.boxSetAlbums && boxSet.boxSetAlbums.length == 0 && (
        <ContentUnavailableNotice
          isLoading={false}
          items={[]}
          emptyIconType={IconType.ListAlt}
          emptyTitle={strings.box_set_no_albums_title}
          emptyDescription={strings.box_set_no_albums_description}
          searchText={""}
          canAdd={false}
        />
      )}
      <AlbumsDesktop
        key={`albums_desktop_${boxSet.uuid}`}
        open={isAlbumsDesktopOpen}
        onClose={() => setIsAlbumsDesktopOpen(false)}
        onAlbumSelected={onAddAlbum}
      />
    </Card>
  );
};

export interface IBoxSetAlbumListProps {
  isPublic: boolean;
  className?: string;
  boxSet: IAlbum;
  onDeleteFromBoxSet: (newBoxSet: IAlbum) => void;
  onAddAlbum: (album: IAlbum) => void;
  onAlbumSelected: (album: IAlbum) => void;
  setLoading: (isLoading: boolean) => void;
}
